import { LinkBuilder } from '../links/definition/linkBuilder';
import { applyState, toSuccess } from '../resolvers/definition/resolverState';
import { applyDefaultsToEgg } from './resource';
import { defaultResourceRegistry } from './resourceRegistry';

// ─── Transform types (self = derived, other = source) ───────────────

// ─── Deprecated transform type ──────────────────────────────────────
/** @deprecated Use DerivedPushTransform */
// ─── Builder ────────────────────────────────────────────────────────
const buildDeriveChain = (name, source, paramMapper, pullTransform) => {
  let identity;
  let hash;
  let pushTransform;
  const deferredLinks = [];
  const register = (__registry = defaultResourceRegistry) => {
    const resource = applyDefaultsToEgg({
      typeName: name,
      identifyInstance: identity,
      hash,
      sources: [{
        resource: source,
        mapParams: paramMapper
      }]
    });

    // self = derived (resource), other = source
    const linkBuilder = new LinkBuilder(resource, source).findOther({
      fromSelfParams: ({
        params
      }) => paramMapper(params)
    }).pullState(({
      dataChanged,
      self,
      other
    }) => {
      var _other$state;
      if (!dataChanged || !((_other$state = other.state) !== null && _other$state !== void 0 && _other$state.data)) {
        return applyState(other.state, self.state);
      }
      const nextData = pullTransform({
        self: {
          params: self.params
        },
        other: {
          params: other.params,
          data: other.state.data
        }
      });
      if (nextData != null) {
        return applyState(other.state, toSuccess(nextData)());
      }
    });
    if (pushTransform) {
      linkBuilder.pushState(({
        dataChanged,
        self,
        other
      }) => {
        var _self$state;
        if (dataChanged && (_self$state = self.state) !== null && _self$state !== void 0 && _self$state.data && other.state) {
          var _other$state2;
          const data = pushTransform({
            self: {
              params: self.params,
              data: self.state.data
            },
            other: {
              params: other.params,
              data: (_other$state2 = other.state) === null || _other$state2 === void 0 ? void 0 : _other$state2.data
            }
          });
          if (data != null) {
            return applyState(other.state, toSuccess(data)());
          }
        }
      });
    }
    const links = [linkBuilder.pullBehavior({
      state: true,
      invalidation: true
    }).pushBehavior({
      state: !!pushTransform,
      invalidation: true
    }).finalize()];
    for (const deferred of deferredLinks) {
      links.push(deferred.construct(new LinkBuilder(resource, deferred.target)).finalize());
    }
    __registry.registerResource(resource, links);
    return resource;
  };
  const linksResult = {
    register,
    linkTo: (linkTgt, construct) => {
      deferredLinks.push({
        target: linkTgt,
        construct: construct
      });
      return linksResult;
    }
  };
  const builder = Object.assign({
    push: fn => {
      pushTransform = fn;
      return builder;
    },
    transformToSource: fn => {
      pushTransform = ({
        self,
        other
      }) => fn({
        sourceParams: other.params,
        sourceData: other.data,
        targetParams: self.params,
        targetData: self.data
      });
      return builder;
    },
    withHash: fn => {
      hash = fn;
      return builder;
    },
    withIdentity: fn => {
      identity = fn;
      return builder;
    }
  }, linksResult);
  return builder;
};
const wrapLegacyPull = transform => ({
  self,
  other
}) => transform({
  sourceData: other.data,
  targetParams: self.params
});
export const deriveResource = name => ({
  from: source => ({
    pull: transform => buildDeriveChain(name, source, p => p, transform),
    /** @deprecated Use `pull` */
    transformToTarget: transform => buildDeriveChain(name, source, p => p, wrapLegacyPull(transform)),
    mapParams: paramMapper => ({
      pull: transform => buildDeriveChain(name, source, paramMapper, transform),
      /** @deprecated Use `pull` */
      transformToTarget: transform => buildDeriveChain(name, source, paramMapper, wrapLegacyPull(transform))
    })
  })
});